import { useEventStore } from "@/event";
import {
	getEventiumIconAssetsForType,
	type MapAssetPair,
} from "@/event/integration/game/eventMapAssetCatalog";

/**
 * Map textures keyed by active timed-event skin (merged into {@link getMapAssets}).
 */
export function getEventConditionalMapAssetFragments(): Record<
	string,
	MapAssetPair
> {
	const eventAttributes = useEventStore().attributes;
	return getEventiumIconAssetsForType(eventAttributes.type);
}
